import * as actionTypes from '../constants/index';
const setLoading = value => {
	return {
		type: actionTypes.SET_LOADING,
		value
	};
};

export { setLoading };
